import {combineReducers, configureStore} from "@reduxjs/toolkit"
import {useDispatch as useStoreDispatch} from "react-redux"
import auth from "./api/AuthSlice";
import {branchApi} from "./api/branchApi";
import {courierApi} from "./api/courierApi";
import {orderApi} from "./api/orderApi";
import {assignApi} from "./api/assignApi";
import {cancelSendingApi} from "./api/cancelSendingApi"
import {productApi} from "./api/productApi";
import {teletechApi} from "./api/teletechApi";

export const reducer = combineReducers({
    [branchApi.reducerPath]: branchApi.reducer,
    [courierApi.reducerPath]: courierApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [assignApi.reducerPath]: assignApi.reducer,
    [cancelSendingApi.reducerPath]: cancelSendingApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [teletechApi.reducerPath]: teletechApi.reducer,
    auth
})

export type StoreState = ReturnType<typeof reducer>
export type AppDispatch = typeof store.dispatch

export const useDispatch = () => useStoreDispatch<AppDispatch>()


export const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({immutableCheck: false})
            .concat(branchApi.middleware)
            .concat(courierApi.middleware)
            .concat(orderApi.middleware)
            .concat(assignApi.middleware)
            .concat(cancelSendingApi.middleware)
            .concat(productApi.middleware)
            .concat(teletechApi.middleware)
})
